window.IR_SECOND_PAGE_PRINTER_CATALOGS = window.IR_SECOND_PAGE_PRINTER_CATALOGS || {};
window.IR_SECOND_PAGE_PRINTER_CATALOGS["canonprinter"] = {
  "groupCount": 30,
  "modelCount": 380,
  "groups": [
    {
      "order": 1,
      "name": "BIJシリーズ",
      "models": [
        {
          "order": 1,
          "model": "BIJ-1300",
          "shopifyUrl": "/collections/bij-1300"
        },
        {
          "order": 2,
          "model": "BIJ-1350",
          "shopifyUrl": "/collections/bij-1350"
        },
        {
          "order": 3,
          "model": "BIJ-1350D",
          "shopifyUrl": "/collections/bij-1350d"
        },
        {
          "order": 4,
          "model": "BIJ-2300",
          "shopifyUrl": "/collections/bij-2300"
        },
        {
          "order": 5,
          "model": "BIJ-2350",
          "shopifyUrl": "/collections/bij-2350"
        }
      ]
    },
    {
      "order": 2,
      "name": "BJシリーズ",
      "models": [
        {
          "order": 1,
          "model": "BJ-10v",
          "shopifyUrl": "/collections/bj-10v"
        },
        {
          "order": 2,
          "model": "BJ-10vCustom",
          "shopifyUrl": "/collections/bj-10vcustom"
        },
        {
          "order": 3,
          "model": "BJ-10vLite",
          "shopifyUrl": "/collections/bj-10vlite"
        },
        {
          "order": 4,
          "model": "BJ-10vSelect",
          "shopifyUrl": "/collections/bj-10vselect"
        },
        {
          "order": 5,
          "model": "BJ-15v",
          "shopifyUrl": "/collections/bj-15v"
        },
        {
          "order": 6,
          "model": "BJ-15vPro",
          "shopifyUrl": "/collections/bj-15vpro"
        },
        {
          "order": 7,
          "model": "BJ-30v",
          "shopifyUrl": "/collections/bj-30v"
        },
        {
          "order": 8,
          "model": "BJ-220JC",
          "shopifyUrl": "/collections/bj-220jc"
        },
        {
          "order": 9,
          "model": "BJ-220JCII",
          "shopifyUrl": "/collections/bj-220jcii"
        },
        {
          "order": 10,
          "model": "BJ-220JS",
          "shopifyUrl": "/collections/bj-220js"
        },
        {
          "order": 11,
          "model": "BJ-220JSII",
          "shopifyUrl": "/collections/bj-220jsii"
        },
        {
          "order": 12,
          "model": "BJ-535PD",
          "shopifyUrl": "/collections/bj-535pd"
        },
        {
          "order": 13,
          "model": "BJ-895PD",
          "shopifyUrl": "/collections/bj-895pd"
        }
      ]
    },
    {
      "order": 3,
      "name": "BJCシリーズ",
      "models": [
        {
          "order": 1,
          "model": "BJC-35v",
          "shopifyUrl": "/collections/bjc-35v"
        },
        {
          "order": 2,
          "model": "BJC-35vII",
          "shopifyUrl": "/collections/bjc-35vii"
        },
        {
          "order": 3,
          "model": "BJC-50v",
          "shopifyUrl": "/collections/bjc-50v"
        },
        {
          "order": 4,
          "model": "BJC-50v-Ti",
          "shopifyUrl": "/collections/bjc-50v-ti"
        },
        {
          "order": 5,
          "model": "BJC-80v",
          "shopifyUrl": "/collections/bjc-80v"
        },
        {
          "order": 6,
          "model": "BJC-210J",
          "shopifyUrl": "/collections/bjc-210j"
        },
        {
          "order": 7,
          "model": "BJC-240J",
          "shopifyUrl": "/collections/bjc-240j"
        },
        {
          "order": 8,
          "model": "BJC-250J",
          "shopifyUrl": "/collections/bjc-250j"
        },
        {
          "order": 9,
          "model": "BJC-250JU",
          "shopifyUrl": "/collections/bjc-250ju"
        },
        {
          "order": 10,
          "model": "BJC-400J",
          "shopifyUrl": "/collections/bjc-400j"
        },
        {
          "order": 11,
          "model": "BJC-410J",
          "shopifyUrl": "/collections/bjc-410j"
        },
        {
          "order": 12,
          "model": "BJC-420J",
          "shopifyUrl": "/collections/bjc-420j"
        },
        {
          "order": 13,
          "model": "BJC-430J",
          "shopifyUrl": "/collections/bjc-430j"
        },
        {
          "order": 14,
          "model": "BJC-430J-Lite",
          "shopifyUrl": "/collections/bjc-430j-lite"
        },
        {
          "order": 15,
          "model": "BJC-430J-USB",
          "shopifyUrl": "/collections/bjc-430j-usb"
        },
        {
          "order": 16,
          "model": "BJC-430JD-Lite",
          "shopifyUrl": "/collections/bjc-430jd-lite"
        },
        {
          "order": 17,
          "model": "BJC-440J",
          "shopifyUrl": "/collections/bjc-440j"
        },
        {
          "order": 18,
          "model": "BJC-455J",
          "shopifyUrl": "/collections/bjc-455j"
        },
        {
          "order": 19,
          "model": "BJC-465J",
          "shopifyUrl": "/collections/bjc-465j"
        },
        {
          "order": 20,
          "model": "BJC-5500J",
          "shopifyUrl": "/collections/bjc-5500j"
        }
      ]
    },
    {
      "order": 4,
      "name": "BJFシリーズ",
      "models": [
        {
          "order": 1,
          "model": "BJF-100",
          "shopifyUrl": "/collections/bjf-100"
        },
        {
          "order": 2,
          "model": "BJF-200",
          "shopifyUrl": "/collections/bjf-200"
        },
        {
          "order": 3,
          "model": "BJF-200u",
          "shopifyUrl": "/collections/bjf-200u"
        },
        {
          "order": 4,
          "model": "BJF-210",
          "shopifyUrl": "/collections/bjf-210"
        },
        {
          "order": 5,
          "model": "BJF-300",
          "shopifyUrl": "/collections/bjf-300"
        },
        {
          "order": 6,
          "model": "BJF-360",
          "shopifyUrl": "/collections/bjf-360"
        },
        {
          "order": 7,
          "model": "BJF-600",
          "shopifyUrl": "/collections/bjf-600"
        },
        {
          "order": 8,
          "model": "BJF-610",
          "shopifyUrl": "/collections/bjf-610"
        },
        {
          "order": 9,
          "model": "BJF-620",
          "shopifyUrl": "/collections/bjf-620"
        },
        {
          "order": 10,
          "model": "BJF-660",
          "shopifyUrl": "/collections/bjf-660"
        },
        {
          "order": 11,
          "model": "BJF-660V",
          "shopifyUrl": "/collections/bjf-660v"
        },
        {
          "order": 12,
          "model": "BJF-850アップグレード",
          "shopifyUrl": "/collections/bjf-850アップグレード"
        },
        {
          "order": 13,
          "model": "BJF-860",
          "shopifyUrl": "/collections/bjf-860"
        },
        {
          "order": 14,
          "model": "BJF-870",
          "shopifyUrl": "/collections/bjf-870"
        },
        {
          "order": 15,
          "model": "BJF-870PD",
          "shopifyUrl": "/collections/bjf-870pd"
        },
        {
          "order": 16,
          "model": "BJF-890",
          "shopifyUrl": "/collections/bjf-890"
        },
        {
          "order": 17,
          "model": "BJF-890PD",
          "shopifyUrl": "/collections/bjf-890pd"
        },
        {
          "order": 18,
          "model": "BJF-900",
          "shopifyUrl": "/collections/bjf-900"
        },
        {
          "order": 19,
          "model": "BJF-930",
          "shopifyUrl": "/collections/bjf-930"
        },
        {
          "order": 20,
          "model": "BJF-6000",
          "shopifyUrl": "/collections/bjf-6000"
        },
        {
          "order": 21,
          "model": "BJF-6100",
          "shopifyUrl": "/collections/bjf-6100"
        },
        {
          "order": 22,
          "model": "BJF-6600",
          "shopifyUrl": "/collections/bjf-6600"
        },
        {
          "order": 23,
          "model": "BJF-9000",
          "shopifyUrl": "/collections/bjf-9000"
        }
      ]
    },
    {
      "order": 5,
      "name": "BJMシリーズ",
      "models": [
        {
          "order": 1,
          "model": "BJM-40",
          "shopifyUrl": "/collections/bjm-40"
        },
        {
          "order": 2,
          "model": "BJM-70",
          "shopifyUrl": "/collections/bjm-70"
        },
        {
          "order": 3,
          "model": "BJM-70PW",
          "shopifyUrl": "/collections/bjm-70pw"
        }
      ]
    },
    {
      "order": 6,
      "name": "BJSシリーズ",
      "models": [
        {
          "order": 1,
          "model": "BJS-200",
          "shopifyUrl": "/collections/bjs-200"
        },
        {
          "order": 2,
          "model": "BJS-300",
          "shopifyUrl": "/collections/bjs-300"
        },
        {
          "order": 3,
          "model": "BJS-330",
          "shopifyUrl": "/collections/bjs-330"
        },
        {
          "order": 4,
          "model": "BJS-500",
          "shopifyUrl": "/collections/bjs-500"
        },
        {
          "order": 5,
          "model": "BJS-530",
          "shopifyUrl": "/collections/bjs-530"
        },
        {
          "order": 6,
          "model": "BJS-600",
          "shopifyUrl": "/collections/bjs-600"
        },
        {
          "order": 7,
          "model": "BJS-630",
          "shopifyUrl": "/collections/bjs-630"
        },
        {
          "order": 8,
          "model": "BJS-700",
          "shopifyUrl": "/collections/bjs-700"
        },
        {
          "order": 9,
          "model": "BJS-6300",
          "shopifyUrl": "/collections/bjs-6300"
        }
      ]
    },
    {
      "order": 7,
      "name": "CF-PL（FAXPHONE）シリーズ",
      "models": [
        {
          "order": 1,
          "model": "CF-PL90",
          "shopifyUrl": "/collections/cf-pl90"
        },
        {
          "order": 2,
          "model": "CF-PL90W",
          "shopifyUrl": "/collections/cf-pl90w"
        },
        {
          "order": 3,
          "model": "CF-PL95",
          "shopifyUrl": "/collections/cf-pl95"
        },
        {
          "order": 4,
          "model": "CF-PL95W",
          "shopifyUrl": "/collections/cf-pl95w"
        }
      ]
    },
    {
      "order": 8,
      "name": "Gシリーズ",
      "models": [
        {
          "order": 1,
          "model": "G1310",
          "shopifyUrl": "/collections/g1310"
        },
        {
          "order": 2,
          "model": "G1330",
          "shopifyUrl": "/collections/g1330"
        },
        {
          "order": 3,
          "model": "G3310",
          "shopifyUrl": "/collections/g3310"
        },
        {
          "order": 4,
          "model": "G3360",
          "shopifyUrl": "/collections/g3360"
        },
        {
          "order": 5,
          "model": "G3370",
          "shopifyUrl": "/collections/g3370"
        },
        {
          "order": 6,
          "model": "G3390",
          "shopifyUrl": "/collections/g3390"
        },
        {
          "order": 7,
          "model": "G5030",
          "shopifyUrl": "/collections/g5030"
        },
        {
          "order": 8,
          "model": "G6030",
          "shopifyUrl": "/collections/g6030"
        },
        {
          "order": 9,
          "model": "G7030",
          "shopifyUrl": "/collections/g7030"
        },
        {
          "order": 10,
          "model": "GX1030",
          "shopifyUrl": "/collections/gx1030"
        },
        {
          "order": 11,
          "model": "GX2030",
          "shopifyUrl": "/collections/gx2030"
        },
        {
          "order": 12,
          "model": "GX4030",
          "shopifyUrl": "/collections/gx4030"
        },
        {
          "order": 13,
          "model": "GX5030",
          "shopifyUrl": "/collections/gx5030"
        },
        {
          "order": 14,
          "model": "GX5530",
          "shopifyUrl": "/collections/gx5530"
        },
        {
          "order": 15,
          "model": "GX6030",
          "shopifyUrl": "/collections/gx6030"
        },
        {
          "order": 16,
          "model": "GX6530",
          "shopifyUrl": "/collections/gx6530"
        },
        {
          "order": 17,
          "model": "GX7030",
          "shopifyUrl": "/collections/gx7030"
        },
        {
          "order": 18,
          "model": "GM2030",
          "shopifyUrl": "/collections/gm2030"
        },
        {
          "order": 19,
          "model": "GM4030",
          "shopifyUrl": "/collections/gm4030"
        }
      ]
    },
    {
      "order": 9,
      "name": "imagePROGRAFシリーズ",
      "models": [
        {
          "order": 1,
          "model": "imagePROGRAF-PRO-G1",
          "shopifyUrl": "/collections/imageprograf-pro-g1"
        },
        {
          "order": 2,
          "model": "imagePROGRAF-iPF8300",
          "shopifyUrl": "/collections/imageprograf-ipf8300"
        },
        {
          "order": 3,
          "model": "imagePROGRAF-iPF8300S",
          "shopifyUrl": "/collections/imageprograf-ipf8300s"
        },
        {
          "order": 4,
          "model": "imagePROGRAF-iPF8400",
          "shopifyUrl": "/collections/imageprograf-ipf8400"
        },
        {
          "order": 5,
          "model": "imagePROGRAF-iPF8400S",
          "shopifyUrl": "/collections/imageprograf-ipf8400s"
        },
        {
          "order": 6,
          "model": "imagePROGRAF-iPF8400SE",
          "shopifyUrl": "/collections/imageprograf-ipf8400se"
        },
        {
          "order": 7,
          "model": "imagePROGRAF-iPF9400",
          "shopifyUrl": "/collections/imageprograf-ipf9400"
        },
        {
          "order": 8,
          "model": "imagePROGRAF-iPF9400S",
          "shopifyUrl": "/collections/imageprograf-ipf9400s"
        },
        {
          "order": 9,
          "model": "iPF500",
          "shopifyUrl": "/collections/ipf500"
        },
        {
          "order": 10,
          "model": "iPF510",
          "shopifyUrl": "/collections/ipf510"
        },
        {
          "order": 11,
          "model": "iPF510plus",
          "shopifyUrl": "/collections/ipf510plus"
        },
        {
          "order": 12,
          "model": "iPF600",
          "shopifyUrl": "/collections/ipf600"
        },
        {
          "order": 13,
          "model": "iPF605",
          "shopifyUrl": "/collections/ipf605"
        },
        {
          "order": 14,
          "model": "iPF605Lplus",
          "shopifyUrl": "/collections/ipf605lplus"
        },
        {
          "order": 15,
          "model": "iPF610",
          "shopifyUrl": "/collections/ipf610"
        },
        {
          "order": 16,
          "model": "iPF610plus",
          "shopifyUrl": "/collections/ipf610plus"
        },
        {
          "order": 17,
          "model": "iPF650",
          "shopifyUrl": "/collections/ipf650"
        },
        {
          "order": 18,
          "model": "iPF655",
          "shopifyUrl": "/collections/ipf655"
        },
        {
          "order": 19,
          "model": "iPF700",
          "shopifyUrl": "/collections/ipf700"
        },
        {
          "order": 20,
          "model": "iPF710",
          "shopifyUrl": "/collections/ipf710"
        },
        {
          "order": 21,
          "model": "iPF720",
          "shopifyUrl": "/collections/ipf720"
        },
        {
          "order": 22,
          "model": "iPF750",
          "shopifyUrl": "/collections/ipf750"
        },
        {
          "order": 23,
          "model": "iPF755",
          "shopifyUrl": "/collections/ipf755"
        },
        {
          "order": 24,
          "model": "iPF760",
          "shopifyUrl": "/collections/ipf760"
        },
        {
          "order": 25,
          "model": "iPF765",
          "shopifyUrl": "/collections/ipf765"
        },
        {
          "order": 26,
          "model": "iPF750-Poster",
          "shopifyUrl": "/collections/ipf750-poster"
        },
        {
          "order": 27,
          "model": "iPF750-School",
          "shopifyUrl": "/collections/ipf750-school"
        },
        {
          "order": 28,
          "model": "IPF680",
          "shopifyUrl": "/collections/ipf680"
        },
        {
          "order": 29,
          "model": "IPF685",
          "shopifyUrl": "/collections/ipf685"
        },
        {
          "order": 30,
          "model": "IPF780",
          "shopifyUrl": "/collections/ipf780"
        },
        {
          "order": 31,
          "model": "IPF785",
          "shopifyUrl": "/collections/ipf785"
        },
        {
          "order": 32,
          "model": "TA-20",
          "shopifyUrl": "/collections/ta-20"
        },
        {
          "order": 33,
          "model": "TA-30",
          "shopifyUrl": "/collections/ta-30"
        },
        {
          "order": 34,
          "model": "TC-20",
          "shopifyUrl": "/collections/tc-20"
        },
        {
          "order": 35,
          "model": "TC-20M",
          "shopifyUrl": "/collections/tc-20m"
        },
        {
          "order": 36,
          "model": "TM-200",
          "shopifyUrl": "/collections/tm-200"
        },
        {
          "order": 37,
          "model": "TM-205",
          "shopifyUrl": "/collections/tm-205"
        },
        {
          "order": 38,
          "model": "TM-240",
          "shopifyUrl": "/collections/tm-240"
        },
        {
          "order": 39,
          "model": "TM-250",
          "shopifyUrl": "/collections/tm-250"
        },
        {
          "order": 40,
          "model": "TM-255",
          "shopifyUrl": "/collections/tm-255"
        },
        {
          "order": 41,
          "model": "TM-300",
          "shopifyUrl": "/collections/tm-300"
        },
        {
          "order": 42,
          "model": "TM-305",
          "shopifyUrl": "/collections/tm-305"
        },
        {
          "order": 43,
          "model": "TM-340",
          "shopifyUrl": "/collections/tm-340"
        },
        {
          "order": 44,
          "model": "TM-350",
          "shopifyUrl": "/collections/tm-350"
        },
        {
          "order": 45,
          "model": "TM-355",
          "shopifyUrl": "/collections/tm-355"
        },
        {
          "order": 46,
          "model": "TM-200MFP",
          "shopifyUrl": "/collections/tm-200mfp"
        },
        {
          "order": 47,
          "model": "TM-300MFP",
          "shopifyUrl": "/collections/tm-300mfp"
        },
        {
          "order": 48,
          "model": "GP-200",
          "shopifyUrl": "/collections/gp-200"
        },
        {
          "order": 49,
          "model": "GP-300",
          "shopifyUrl": "/collections/gp-300"
        }
      ]
    },
    {
      "order": 10,
      "name": "MAXIFY-iBシリーズ",
      "models": [
        {
          "order": 1,
          "model": "MAXIFY-iB4030",
          "shopifyUrl": "/collections/maxify-ib4030"
        },
        {
          "order": 2,
          "model": "MAXIFY-iB4130",
          "shopifyUrl": "/collections/maxify-ib4130"
        }
      ]
    },
    {
      "order": 11,
      "name": "MAXIFY-MBシリーズ",
      "models": [
        {
          "order": 1,
          "model": "MAXIFY-MB2030",
          "shopifyUrl": "/collections/maxify-mb2030"
        },
        {
          "order": 2,
          "model": "MAXIFY-MB2130",
          "shopifyUrl": "/collections/maxify-mb2130"
        },
        {
          "order": 3,
          "model": "MAXIFY-MB2330",
          "shopifyUrl": "/collections/maxify-mb2330"
        },
        {
          "order": 4,
          "model": "MAXIFY-MB2730",
          "shopifyUrl": "/collections/maxify-mb2730"
        },
        {
          "order": 5,
          "model": "MAXIFY-MB5030",
          "shopifyUrl": "/collections/maxify-mb5030"
        },
        {
          "order": 6,
          "model": "MAXIFY-MB5130",
          "shopifyUrl": "/collections/maxify-mb5130"
        },
        {
          "order": 7,
          "model": "MAXIFY-MB5330",
          "shopifyUrl": "/collections/maxify-mb5330"
        },
        {
          "order": 8,
          "model": "MAXIFY-MB5430",
          "shopifyUrl": "/collections/maxify-mb5430"
        }
      ]
    },
    {
      "order": 12,
      "name": "MultiPASS-Bシリーズ",
      "models": [
        {
          "order": 1,
          "model": "MultiPASS-B30",
          "shopifyUrl": "/collections/multipass-b30"
        }
      ]
    },
    {
      "order": 13,
      "name": "MultiPASS-Cシリーズ",
      "models": [
        {
          "order": 1,
          "model": "MultiPASS-C50",
          "shopifyUrl": "/collections/multipass-c50"
        },
        {
          "order": 2,
          "model": "MultiPASS-C70",
          "shopifyUrl": "/collections/multipass-c70"
        }
      ]
    },
    {
      "order": 14,
      "name": "NTTFAX",
      "models": [
        {
          "order": 1,
          "model": "NTTFAX-JC-260CL",
          "shopifyUrl": "/collections/nttfax-jc-260cl"
        }
      ]
    },
    {
      "order": 15,
      "name": "PIXUSシリーズ",
      "models": [
        {
          "order": 1,
          "model": "PIXUS-50i",
          "shopifyUrl": "/collections/pixus-50i"
        },
        {
          "order": 2,
          "model": "PIXUS-80i",
          "shopifyUrl": "/collections/pixus-80i"
        },
        {
          "order": 3,
          "model": "PIXUS-320i",
          "shopifyUrl": "/collections/pixus-320i"
        },
        {
          "order": 4,
          "model": "PIXUS-450i",
          "shopifyUrl": "/collections/pixus-450i"
        },
        {
          "order": 5,
          "model": "PIXUS-455i",
          "shopifyUrl": "/collections/pixus-455i"
        },
        {
          "order": 6,
          "model": "PIXUS-470PD",
          "shopifyUrl": "/collections/pixus-470pd"
        },
        {
          "order": 7,
          "model": "PIXUS-475PD",
          "shopifyUrl": "/collections/pixus-475pd"
        },
        {
          "order": 8,
          "model": "PIXUS-550i",
          "shopifyUrl": "/collections/pixus-550i"
        },
        {
          "order": 9,
          "model": "PIXUS-560i",
          "shopifyUrl": "/collections/pixus-560i"
        },
        {
          "order": 10,
          "model": "PIXUS-850i",
          "shopifyUrl": "/collections/pixus-850i"
        },
        {
          "order": 11,
          "model": "PIXUS-860i",
          "shopifyUrl": "/collections/pixus-860i"
        },
        {
          "order": 12,
          "model": "PIXUS-865R",
          "shopifyUrl": "/collections/pixus-865r"
        },
        {
          "order": 13,
          "model": "PIXUS-900PD",
          "shopifyUrl": "/collections/pixus-900pd"
        },
        {
          "order": 14,
          "model": "PIXUS-950i",
          "shopifyUrl": "/collections/pixus-950i"
        },
        {
          "order": 15,
          "model": "PIXUS-960i",
          "shopifyUrl": "/collections/pixus-960i"
        },
        {
          "order": 16,
          "model": "PIXUS-990i",
          "shopifyUrl": "/collections/pixus-990i"
        },
        {
          "order": 17,
          "model": "PIXUS-6100i",
          "shopifyUrl": "/collections/pixus-6100i"
        },
        {
          "order": 18,
          "model": "PIXUS-6500i",
          "shopifyUrl": "/collections/pixus-6500i"
        },
        {
          "order": 19,
          "model": "PIXUS-9100i",
          "shopifyUrl": "/collections/pixus-9100i"
        },
        {
          "order": 20,
          "model": "PIXUS-9900i",
          "shopifyUrl": "/collections/pixus-9900i"
        }
      ]
    },
    {
      "order": 16,
      "name": "PIXUS-iPシリーズ",
      "models": [
        {
          "order": 1,
          "model": "PIXUS-iP90",
          "shopifyUrl": "/collections/pixus-ip90"
        },
        {
          "order": 2,
          "model": "PIXUS-iP90v",
          "shopifyUrl": "/collections/pixus-ip90v"
        },
        {
          "order": 3,
          "model": "PIXUS-iP100",
          "shopifyUrl": "/collections/pixus-ip100"
        },
        {
          "order": 4,
          "model": "PIXUS-iP110",
          "shopifyUrl": "/collections/pixus-ip110"
        },
        {
          "order": 5,
          "model": "PIXUS-iP1500",
          "shopifyUrl": "/collections/pixus-ip1500"
        },
        {
          "order": 6,
          "model": "PIXUS-iP2000",
          "shopifyUrl": "/collections/pixus-ip2000"
        },
        {
          "order": 7,
          "model": "PIXUS-iP2700",
          "shopifyUrl": "/collections/pixus-ip2700"
        },
        {
          "order": 8,
          "model": "PIXUS-iP3100",
          "shopifyUrl": "/collections/pixus-ip3100"
        },
        {
          "order": 9,
          "model": "PIXUS-iP3300",
          "shopifyUrl": "/collections/pixus-ip3300"
        },
        {
          "order": 10,
          "model": "PIXUS-iP3500",
          "shopifyUrl": "/collections/pixus-ip3500"
        },
        {
          "order": 11,
          "model": "PIXUS-iP3600",
          "shopifyUrl": "/collections/pixus-ip3600"
        },
        {
          "order": 12,
          "model": "PIXUS-iP4100",
          "shopifyUrl": "/collections/pixus-ip4100"
        },
        {
          "order": 13,
          "model": "PIXUS-iP4100R",
          "shopifyUrl": "/collections/pixus-ip4100r"
        },
        {
          "order": 14,
          "model": "PIXUS-iP4200",
          "shopifyUrl": "/collections/pixus-ip4200"
        },
        {
          "order": 15,
          "model": "PIXUS-iP4300",
          "shopifyUrl": "/collections/pixus-ip4300"
        },
        {
          "order": 16,
          "model": "PIXUS-iP4500",
          "shopifyUrl": "/collections/pixus-ip4500"
        },
        {
          "order": 17,
          "model": "PIXUS-iP4600",
          "shopifyUrl": "/collections/pixus-ip4600"
        },
        {
          "order": 18,
          "model": "PIXUS-iP4700",
          "shopifyUrl": "/collections/pixus-ip4700"
        },
        {
          "order": 19,
          "model": "PIXUS-iP4830",
          "shopifyUrl": "/collections/pixus-ip4830"
        },
        {
          "order": 20,
          "model": "PIXUS-iP4930",
          "shopifyUrl": "/collections/pixus-ip4930"
        },
        {
          "order": 21,
          "model": "PIXUS-iP5200R",
          "shopifyUrl": "/collections/pixus-ip5200r"
        },
        {
          "order": 22,
          "model": "PIXUS-iP6100D",
          "shopifyUrl": "/collections/pixus-ip6100d"
        },
        {
          "order": 23,
          "model": "PIXUS-iP6600D",
          "shopifyUrl": "/collections/pixus-ip6600d"
        },
        {
          "order": 24,
          "model": "PIXUS-iP6700D",
          "shopifyUrl": "/collections/pixus-ip6700d"
        },
        {
          "order": 25,
          "model": "PIXUS-iP7100",
          "shopifyUrl": "/collections/pixus-ip7100"
        },
        {
          "order": 26,
          "model": "PIXUS-iP7230",
          "shopifyUrl": "/collections/pixus-ip7230"
        },
        {
          "order": 27,
          "model": "PIXUS-iP7500",
          "shopifyUrl": "/collections/pixus-ip7500"
        },
        {
          "order": 28,
          "model": "PIXUS-iP8100",
          "shopifyUrl": "/collections/pixus-ip8100"
        },
        {
          "order": 29,
          "model": "PIXUS-iP8730",
          "shopifyUrl": "/collections/pixus-ip8730"
        },
        {
          "order": 30,
          "model": "PIXUS-iP9910",
          "shopifyUrl": "/collections/pixus-ip9910"
        }
      ]
    },
    {
      "order": 17,
      "name": "PIXUS-iXシリーズ",
      "models": [
        {
          "order": 1,
          "model": "PIXUS-iX5000",
          "shopifyUrl": "/collections/pixus-ix5000"
        },
        {
          "order": 2,
          "model": "PIXUS-iX6530",
          "shopifyUrl": "/collections/pixus-ix6530"
        },
        {
          "order": 3,
          "model": "PIXUS-iX6830",
          "shopifyUrl": "/collections/pixus-ix6830"
        },
        {
          "order": 4,
          "model": "PIXUS-iX7000",
          "shopifyUrl": "/collections/pixus-ix7000"
        }
      ]
    },
    {
      "order": 18,
      "name": "PIXUS-MGシリーズ",
      "models": [
        {
          "order": 1,
          "model": "PIXUS-MG2130",
          "shopifyUrl": "/collections/pixus-mg2130"
        },
        {
          "order": 2,
          "model": "PIXUS-MG3130",
          "shopifyUrl": "/collections/pixus-mg3130"
        },
        {
          "order": 3,
          "model": "PIXUS-MG3230",
          "shopifyUrl": "/collections/pixus-mg3230"
        },
        {
          "order": 4,
          "model": "PIXUS-MG3530",
          "shopifyUrl": "/collections/pixus-mg3530"
        },
        {
          "order": 5,
          "model": "PIXUS-MG3630",
          "shopifyUrl": "/collections/pixus-mg3630"
        },
        {
          "order": 6,
          "model": "PIXUS-MG4130",
          "shopifyUrl": "/collections/pixus-mg4130"
        },
        {
          "order": 7,
          "model": "PIXUS-MG4230",
          "shopifyUrl": "/collections/pixus-mg4230"
        },
        {
          "order": 8,
          "model": "PIXUS-MG5130",
          "shopifyUrl": "/collections/pixus-mg5130"
        },
        {
          "order": 9,
          "model": "PIXUS-MG5230",
          "shopifyUrl": "/collections/pixus-mg5230"
        },
        {
          "order": 10,
          "model": "PIXUS-MG5330",
          "shopifyUrl": "/collections/pixus-mg5330"
        },
        {
          "order": 11,
          "model": "PIXUS-MG5430",
          "shopifyUrl": "/collections/pixus-mg5430"
        },
        {
          "order": 12,
          "model": "PIXUS-MG5530",
          "shopifyUrl": "/collections/pixus-mg5530"
        },
        {
          "order": 13,
          "model": "PIXUS-MG5630",
          "shopifyUrl": "/collections/pixus-mg5630"
        },
        {
          "order": 14,
          "model": "PIXUS-MG5730",
          "shopifyUrl": "/collections/pixus-mg5730"
        },
        {
          "order": 15,
          "model": "PIXUS-MG6130",
          "shopifyUrl": "/collections/pixus-mg6130"
        },
        {
          "order": 16,
          "model": "PIXUS-MG6230",
          "shopifyUrl": "/collections/pixus-mg6230"
        },
        {
          "order": 17,
          "model": "PIXUS-MG6330",
          "shopifyUrl": "/collections/pixus-mg6330"
        },
        {
          "order": 18,
          "model": "PIXUS-MG6530",
          "shopifyUrl": "/collections/pixus-mg6530"
        },
        {
          "order": 19,
          "model": "PIXUS-MG6730",
          "shopifyUrl": "/collections/pixus-mg6730"
        },
        {
          "order": 20,
          "model": "PIXUS-MG6930",
          "shopifyUrl": "/collections/pixus-mg6930"
        },
        {
          "order": 21,
          "model": "PIXUS-MG7130",
          "shopifyUrl": "/collections/pixus-mg7130"
        },
        {
          "order": 22,
          "model": "PIXUS-MG7530",
          "shopifyUrl": "/collections/pixus-mg7530"
        },
        {
          "order": 23,
          "model": "PIXUS-MG7530F",
          "shopifyUrl": "/collections/pixus-mg7530f"
        },
        {
          "order": 24,
          "model": "PIXUS-MG7730",
          "shopifyUrl": "/collections/pixus-mg7730"
        },
        {
          "order": 25,
          "model": "PIXUS-MG7730F",
          "shopifyUrl": "/collections/pixus-mg7730f"
        },
        {
          "order": 26,
          "model": "PIXUS-MG8130",
          "shopifyUrl": "/collections/pixus-mg8130"
        },
        {
          "order": 27,
          "model": "PIXUS-MG8230",
          "shopifyUrl": "/collections/pixus-mg8230"
        }
      ]
    },
    {
      "order": 19,
      "name": "PIXUS-miniシリーズ",
      "models": [
        {
          "order": 1,
          "model": "PIXUS-mini220",
          "shopifyUrl": "/collections/pixus-mini220"
        },
        {
          "order": 2,
          "model": "PIXUS-mini260",
          "shopifyUrl": "/collections/pixus-mini260"
        },
        {
          "order": 3,
          "model": "PIXUS-mini360",
          "shopifyUrl": "/collections/pixus-mini360"
        }
      ]
    },
    {
      "order": 20,
      "name": "PIXUS-MPシリーズ",
      "models": [
        {
          "order": 1,
          "model": "PIXUS-MP5",
          "shopifyUrl": "/collections/pixus-mp5"
        },
        {
          "order": 2,
          "model": "PIXUS-MP10",
          "shopifyUrl": "/collections/pixus-mp10"
        },
        {
          "order": 3,
          "model": "PIXUS-MP55",
          "shopifyUrl": "/collections/pixus-mp55"
        },
        {
          "order": 4,
          "model": "PIXUS-MP270",
          "shopifyUrl": "/collections/pixus-mp270"
        },
        {
          "order": 5,
          "model": "PIXUS-MP280",
          "shopifyUrl": "/collections/pixus-mp280"
        },
        {
          "order": 6,
          "model": "PIXUS-MP360",
          "shopifyUrl": "/collections/pixus-mp360"
        },
        {
          "order": 7,
          "model": "PIXUS-MP370",
          "shopifyUrl": "/collections/pixus-mp370"
        },
        {
          "order": 8,
          "model": "PIXUS-MP375R",
          "shopifyUrl": "/collections/pixus-mp375r"
        },
        {
          "order": 9,
          "model": "PIXUS-MP390",
          "shopifyUrl": "/collections/pixus-mp390"
        },
        {
          "order": 10,
          "model": "PIXUS-MP480",
          "shopifyUrl": "/collections/pixus-mp480"
        },
        {
          "order": 11,
          "model": "PIXUS-MP490",
          "shopifyUrl": "/collections/pixus-mp490"
        },
        {
          "order": 12,
          "model": "PIXUS-MP493",
          "shopifyUrl": "/collections/pixus-mp493"
        },
        {
          "order": 13,
          "model": "PIXUS-MP500",
          "shopifyUrl": "/collections/pixus-mp500"
        },
        {
          "order": 14,
          "model": "PIXUS-MP510",
          "shopifyUrl": "/collections/pixus-mp510"
        },
        {
          "order": 15,
          "model": "PIXUS-MP520",
          "shopifyUrl": "/collections/pixus-mp520"
        },
        {
          "order": 16,
          "model": "PIXUS-MP540",
          "shopifyUrl": "/collections/pixus-mp540"
        },
        {
          "order": 17,
          "model": "PIXUS-MP550",
          "shopifyUrl": "/collections/pixus-mp550"
        },
        {
          "order": 18,
          "model": "PIXUS-MP560",
          "shopifyUrl": "/collections/pixus-mp560"
        },
        {
          "order": 19,
          "model": "PIXUS-MP600",
          "shopifyUrl": "/collections/pixus-mp600"
        },
        {
          "order": 20,
          "model": "PIXUS-MP610",
          "shopifyUrl": "/collections/pixus-mp610"
        },
        {
          "order": 21,
          "model": "PIXUS-MP620",
          "shopifyUrl": "/collections/pixus-mp620"
        },
        {
          "order": 22,
          "model": "PIXUS-MP630",
          "shopifyUrl": "/collections/pixus-mp630"
        },
        {
          "order": 23,
          "model": "PIXUS-MP640",
          "shopifyUrl": "/collections/pixus-mp640"
        },
        {
          "order": 24,
          "model": "PIXUS-MP700",
          "shopifyUrl": "/collections/pixus-mp700"
        },
        {
          "order": 25,
          "model": "PIXUS-MP710",
          "shopifyUrl": "/collections/pixus-mp710"
        },
        {
          "order": 26,
          "model": "PIXUS-MP730",
          "shopifyUrl": "/collections/pixus-mp730"
        },
        {
          "order": 27,
          "model": "PIXUS-MP740",
          "shopifyUrl": "/collections/pixus-mp740"
        },
        {
          "order": 28,
          "model": "PIXUS-MP770",
          "shopifyUrl": "/collections/pixus-mp770"
        },
        {
          "order": 29,
          "model": "PIXUS-MP790",
          "shopifyUrl": "/collections/pixus-mp790"
        },
        {
          "order": 30,
          "model": "PIXUS-MP800",
          "shopifyUrl": "/collections/pixus-mp800"
        },
        {
          "order": 31,
          "model": "PIXUS-MP810",
          "shopifyUrl": "/collections/pixus-mp810"
        },
        {
          "order": 32,
          "model": "PIXUS-MP830",
          "shopifyUrl": "/collections/pixus-mp830"
        },
        {
          "order": 33,
          "model": "PIXUS-MP900",
          "shopifyUrl": "/collections/pixus-mp900"
        },
        {
          "order": 34,
          "model": "PIXUS-MP950",
          "shopifyUrl": "/collections/pixus-mp950"
        },
        {
          "order": 35,
          "model": "PIXUS-MP960",
          "shopifyUrl": "/collections/pixus-mp960"
        },
        {
          "order": 36,
          "model": "PIXUS-MP970",
          "shopifyUrl": "/collections/pixus-mp970"
        },
        {
          "order": 37,
          "model": "PIXUS-MP980",
          "shopifyUrl": "/collections/pixus-mp980"
        },
        {
          "order": 38,
          "model": "PIXUS-MP990",
          "shopifyUrl": "/collections/pixus-mp990"
        }
      ]
    },
    {
      "order": 21,
      "name": "PIXUS-MXシリーズ",
      "models": [
        {
          "order": 1,
          "model": "PIXUS-MX420",
          "shopifyUrl": "/collections/pixus-mx420"
        },
        {
          "order": 2,
          "model": "PIXUS-MX850",
          "shopifyUrl": "/collections/pixus-mx850"
        },
        {
          "order": 3,
          "model": "PIXUS-MX860",
          "shopifyUrl": "/collections/pixus-mx860"
        },
        {
          "order": 4,
          "model": "PIXUS-MX870",
          "shopifyUrl": "/collections/pixus-mx870"
        },
        {
          "order": 5,
          "model": "PIXUS-MX883",
          "shopifyUrl": "/collections/pixus-mx883"
        },
        {
          "order": 6,
          "model": "PIXUS-MX893",
          "shopifyUrl": "/collections/pixus-mx893"
        },
        {
          "order": 7,
          "model": "PIXUS-MX923",
          "shopifyUrl": "/collections/pixus-mx923"
        },
        {
          "order": 8,
          "model": "PIXUS-MX7600",
          "shopifyUrl": "/collections/pixus-mx7600"
        }
      ]
    },
    {
      "order": 22,
      "name": "PIXUS-Proシリーズ",
      "models": [
        {
          "order": 1,
          "model": "PIXUS-PRO-S1",
          "shopifyUrl": "/collections/pixus-pro-s1"
        },
        {
          "order": 2,
          "model": "PIXUS-PRO-10",
          "shopifyUrl": "/collections/pixus-pro-10"
        },
        {
          "order": 3,
          "model": "PIXUS-PRO-10S",
          "shopifyUrl": "/collections/pixus-pro-10s"
        },
        {
          "order": 4,
          "model": "PIXUS-PRO-100",
          "shopifyUrl": "/collections/pixus-pro-100"
        },
        {
          "order": 5,
          "model": "PIXUS-PRO-100S",
          "shopifyUrl": "/collections/pixus-pro-100s"
        },
        {
          "order": 6,
          "model": "PIXUS-Pro9000",
          "shopifyUrl": "/collections/pixus-pro9000"
        },
        {
          "order": 7,
          "model": "PIXUS-Pro9000-MarkⅡ",
          "shopifyUrl": "/collections/pixus-pro9000markⅱ"
        },
        {
          "order": 8,
          "model": "PIXUS-Pro9500",
          "shopifyUrl": "/collections/pixus-pro9500"
        },
        {
          "order": 9,
          "model": "PIXUS-Pro9500-MarkII",
          "shopifyUrl": "/collections/pixus-pro9500-markii"
        }
      ]
    },
    {
      "order": 23,
      "name": "PIXUS-SELPHYシリーズ",
      "models": [
        {
          "order": 1,
          "model": "PIXUS-SELPHY-DS700",
          "shopifyUrl": "/collections/pixus-selphy-ds700"
        },
        {
          "order": 2,
          "model": "PIXUS-SELPHY-DS810",
          "shopifyUrl": "/collections/pixus-selphy-ds810"
        }
      ]
    },
    {
      "order": 24,
      "name": "PIXUS-TRシリーズ",
      "models": [
        {
          "order": 1,
          "model": "PIXUS-TR703",
          "shopifyUrl": "/collections/pixus-tr703"
        },
        {
          "order": 2,
          "model": "TR703a",
          "shopifyUrl": "/collections/tr703a"
        },
        {
          "order": 3,
          "model": "PIXUS-TR7530",
          "shopifyUrl": "/collections/pixus-tr7530"
        },
        {
          "order": 4,
          "model": "PIXUS-TR8530",
          "shopifyUrl": "/collections/pixus-tr8530"
        },
        {
          "order": 5,
          "model": "PIXUS-TR8630",
          "shopifyUrl": "/collections/pixus-tr8630"
        },
        {
          "order": 6,
          "model": "TR8630a",
          "shopifyUrl": "/collections/tr8630a"
        },
        {
          "order": 7,
          "model": "TR153",
          "shopifyUrl": "/collections/tr153"
        },
        {
          "order": 8,
          "model": "PIXUS-TR9530",
          "shopifyUrl": "/collections/pixus-tr9530"
        },
        {
          "order": 9,
          "model": "TR9530a",
          "shopifyUrl": "/collections/tr9530a"
        }
      ]
    },
    {
      "order": 25,
      "name": "PIXUS-TSシリーズ",
      "models": [
        {
          "order": 1,
          "model": "PIXUS-TS203",
          "shopifyUrl": "/collections/pixus-ts203"
        },
        {
          "order": 2,
          "model": "PIXUS-TS3130",
          "shopifyUrl": "/collections/pixus-ts3130"
        },
        {
          "order": 3,
          "model": "PIXUS-TS3130S",
          "shopifyUrl": "/collections/pixus-ts3130s"
        },
        {
          "order": 4,
          "model": "PIXUS-TS3330",
          "shopifyUrl": "/collections/pixus-ts3330"
        },
        {
          "order": 5,
          "model": "PIXUS-TS3530",
          "shopifyUrl": "/collections/pixus-ts3530"
        },
        {
          "order": 6,
          "model": "PIXUS-TS3730",
          "shopifyUrl": "/collections/pixus-ts3730"
        },
        {
          "order": 7,
          "model": "PIXUS-TS5030",
          "shopifyUrl": "/collections/pixus-ts5030"
        },
        {
          "order": 8,
          "model": "PIXUS-TS5030S",
          "shopifyUrl": "/collections/pixus-ts5030s"
        },
        {
          "order": 9,
          "model": "PIXUS-TS5130",
          "shopifyUrl": "/collections/pixus-ts5130"
        },
        {
          "order": 10,
          "model": "PIXUS-TS5130S",
          "shopifyUrl": "/collections/pixus-ts5130s"
        },
        {
          "order": 11,
          "model": "PIXUS-TS5330",
          "shopifyUrl": "/collections/pixus-ts5330"
        },
        {
          "order": 12,
          "model": "PIXUS-TS5430",
          "shopifyUrl": "/collections/pixus-ts5430"
        },
        {
          "order": 13,
          "model": "PIXUS-TS6030",
          "shopifyUrl": "/collections/pixus-ts6030"
        },
        {
          "order": 14,
          "model": "PIXUS-TS6130",
          "shopifyUrl": "/collections/pixus-ts6130"
        },
        {
          "order": 15,
          "model": "PIXUS-TS6230",
          "shopifyUrl": "/collections/pixus-ts6230"
        },
        {
          "order": 16,
          "model": "PIXUS-TS6330",
          "shopifyUrl": "/collections/pixus-ts6330"
        },
        {
          "order": 17,
          "model": "PIXUS-TS6630",
          "shopifyUrl": "/collections/pixus-ts6630"
        },
        {
          "order": 18,
          "model": "PIXUS-TS6730",
          "shopifyUrl": "/collections/pixus-ts6730"
        },
        {
          "order": 19,
          "model": "PIXUS-TS7330",
          "shopifyUrl": "/collections/pixus-ts7330"
        },
        {
          "order": 20,
          "model": "PIXUS-TS7430",
          "shopifyUrl": "/collections/pixus-ts7430"
        },
        {
          "order": 21,
          "model": "PIXUS-TS7530",
          "shopifyUrl": "/collections/pixus-ts7530"
        },
        {
          "order": 22,
          "model": "PIXUS-TS7630",
          "shopifyUrl": "/collections/pixus-ts7630"
        },
        {
          "order": 23,
          "model": "PIXUS-TS8030",
          "shopifyUrl": "/collections/pixus-ts8030"
        },
        {
          "order": 24,
          "model": "PIXUS-TS8130",
          "shopifyUrl": "/collections/pixus-ts8130"
        },
        {
          "order": 25,
          "model": "PIXUS-TS8230",
          "shopifyUrl": "/collections/pixus-ts8230"
        },
        {
          "order": 26,
          "model": "PIXUS-TS8330",
          "shopifyUrl": "/collections/pixus-ts8330"
        },
        {
          "order": 27,
          "model": "PIXUS-TS8430",
          "shopifyUrl": "/collections/pixus-ts8430"
        },
        {
          "order": 28,
          "model": "PIXUS-TS8530",
          "shopifyUrl": "/collections/pixus-ts8530"
        },
        {
          "order": 29,
          "model": "PIXUS-TS8630",
          "shopifyUrl": "/collections/pixus-ts8630"
        },
        {
          "order": 30,
          "model": "PIXUS-TS8730",
          "shopifyUrl": "/collections/pixus-ts8730"
        },
        {
          "order": 31,
          "model": "PIXUS-TS8830",
          "shopifyUrl": "/collections/pixus-ts8830"
        },
        {
          "order": 32,
          "model": "PIXUS-TS8930",
          "shopifyUrl": "/collections/pixus-ts8930"
        },
        {
          "order": 33,
          "model": "PIXUS-TS9030",
          "shopifyUrl": "/collections/pixus-ts9030"
        }
      ]
    },
    {
      "order": 26,
      "name": "PIXUS-XKシリーズ",
      "models": [
        {
          "order": 1,
          "model": "PIXUS-XK50",
          "shopifyUrl": "/collections/pixus-xk50"
        },
        {
          "order": 2,
          "model": "PIXUS-XK60",
          "shopifyUrl": "/collections/pixus-xk60"
        },
        {
          "order": 3,
          "model": "PIXUS-XK70",
          "shopifyUrl": "/collections/pixus-xk70"
        },
        {
          "order": 4,
          "model": "PIXUS-XK80",
          "shopifyUrl": "/collections/pixus-xk80"
        },
        {
          "order": 5,
          "model": "PIXUS-XK90",
          "shopifyUrl": "/collections/pixus-xk90"
        },
        {
          "order": 6,
          "model": "PIXUS-XK100",
          "shopifyUrl": "/collections/pixus-xk100"
        },
        {
          "order": 7,
          "model": "PIXUS-XK110",
          "shopifyUrl": "/collections/pixus-xk110"
        },
        {
          "order": 8,
          "model": "PIXUS-XK120",
          "shopifyUrl": "/collections/pixus-xk120"
        },
        {
          "order": 9,
          "model": "PIXUS-XK130",
          "shopifyUrl": "/collections/pixus-xk130"
        },
        {
          "order": 10,
          "model": "PIXUS-XK140",
          "shopifyUrl": "/collections/pixus-xk140"
        },
        {
          "order": 11,
          "model": "PIXUS-XK500",
          "shopifyUrl": "/collections/pixus-xk500"
        },
        {
          "order": 12,
          "model": "PIXUS-XK510",
          "shopifyUrl": "/collections/pixus-xk510"
        }
      ]
    },
    {
      "order": 27,
      "name": "satera-Nシリーズ",
      "models": [
        {
          "order": 1,
          "model": "satera-N1000",
          "shopifyUrl": "/collections/satera-n1000"
        },
        {
          "order": 2,
          "model": "satera-N1100",
          "shopifyUrl": "/collections/satera-n1100"
        },
        {
          "order": 3,
          "model": "satera-N2000",
          "shopifyUrl": "/collections/satera-n2000"
        },
        {
          "order": 4,
          "model": "satera-N2100",
          "shopifyUrl": "/collections/satera-n2100"
        }
      ]
    },
    {
      "order": 28,
      "name": "キヤノワードCW-αシリーズ",
      "models": [
        {
          "order": 1,
          "model": "CW-α7-SUPER",
          "shopifyUrl": "/collections/cw-α7-super"
        },
        {
          "order": 2,
          "model": "CW-α40",
          "shopifyUrl": "/collections/cw-α40"
        },
        {
          "order": 3,
          "model": "CW-α45",
          "shopifyUrl": "/collections/cw-α45"
        },
        {
          "order": 4,
          "model": "CW-α50",
          "shopifyUrl": "/collections/cw-α50"
        },
        {
          "order": 5,
          "model": "CW-α60",
          "shopifyUrl": "/collections/cw-α60"
        },
        {
          "order": 6,
          "model": "CW-α65B",
          "shopifyUrl": "/collections/cw-α65b"
        },
        {
          "order": 7,
          "model": "CW-α65W",
          "shopifyUrl": "/collections/cw-α65w"
        },
        {
          "order": 8,
          "model": "CW-α70",
          "shopifyUrl": "/collections/cw-α70"
        },
        {
          "order": 9,
          "model": "CW-α75",
          "shopifyUrl": "/collections/cw-α75"
        },
        {
          "order": 10,
          "model": "CW-α80",
          "shopifyUrl": "/collections/cw-α80"
        },
        {
          "order": 11,
          "model": "CW-α85",
          "shopifyUrl": "/collections/cw-α85"
        },
        {
          "order": 12,
          "model": "CW-α85HG",
          "shopifyUrl": "/collections/cw-α85hg"
        },
        {
          "order": 13,
          "model": "CW-α250",
          "shopifyUrl": "/collections/cw-α250"
        },
        {
          "order": 14,
          "model": "CW-α260",
          "shopifyUrl": "/collections/cw-α260"
        },
        {
          "order": 15,
          "model": "CW-α360",
          "shopifyUrl": "/collections/cw-α360"
        },
        {
          "order": 16,
          "model": "CW-α370",
          "shopifyUrl": "/collections/cw-α370"
        }
      ]
    },
    {
      "order": 29,
      "name": "キヤノワードCW-Jシリーズ",
      "models": [
        {
          "order": 1,
          "model": "CW-J5",
          "shopifyUrl": "/collections/cw-j5"
        },
        {
          "order": 2,
          "model": "CW-J7",
          "shopifyUrl": "/collections/cw-j7"
        },
        {
          "order": 3,
          "model": "CW-J10",
          "shopifyUrl": "/collections/cw-j10"
        },
        {
          "order": 4,
          "model": "CW-J20",
          "shopifyUrl": "/collections/cw-j20"
        }
      ]
    },
    {
      "order": 30,
      "name": "でんえもん",
      "models": [
        {
          "order": 1,
          "model": "761LC",
          "shopifyUrl": "/collections/761lc"
        },
        {
          "order": 2,
          "model": "762CL",
          "shopifyUrl": "/collections/762cl"
        }
      ]
    }
  ]
};
